import { devError } from './devLog';

/**
 * Determines the sectional committee ID for a given user based on their roles and committee memberships
 * @param {Object} userDetails - User details object containing roles and id
 * @param {Array} committeeArray - Array of committee objects with chair, member, and observer data
 * @returns {number|null} - The sectional committee ID or null if not found
 */
export const getUserSectionalCommittee = (userDetails, committeeArray) => {
  try {
    const { roles, id } = userDetails || {};

    if (
      !roles ||
      !id ||
      !Array.isArray(committeeArray) ||
      committeeArray.length === 0
    ) {
      return null;
    }

    const isSecretary = roles.includes('secretary');
    const isSuperAdmin = roles.includes('super-admin');
    const isAdmin = roles.includes('admin');

    if (isSecretary || isSuperAdmin || isAdmin) {
      return null;
    }

    const isCommitteeChair = roles.includes('committee-chair');
    const isCommitteeMember = roles.includes('committee-member');
    const isCommitteeObserver = roles.includes('council-observer');

    if (!isCommitteeChair && !isCommitteeMember && !isCommitteeObserver) {
      return null;
    }

    const isUserInCommittee = (committee) => {
      if (isCommitteeChair) {
        return committee.attributes?.committeeChair?.data?.id === id;
      }

      if (isCommitteeMember) {
        return committee.attributes?.committeeMembers?.data?.some(
          (member) => member.id === id,
        );
      }

      if (isCommitteeObserver) {
        return committee.attributes?.councilObservers?.data?.some(
          (observer) => observer.id === id,
        );
      }

      return false;
    };

    const userCommittee = committeeArray.find(isUserInCommittee);
    return userCommittee?.id || null;
  } catch (error) {
    devError('Error in getUserSectionalCommittee:', error);
    return null;
  }
};
